import React, {Component} from 'react';
import { View, Text} from 'react-native';

import { cf } from './cf';
import { ce } from './ce';
import { ic } from './ic';
import { bf } from './bf';
import { iv } from './iv';


class cLgn extends React.Component {

  state = cf.myRN_crt_stss({
//    sgcd_pageCmns: {},
    sb_cookie: false,
  })

  componentDidMount() {
    const _o_this = this;
    cf.myRN_stt(this, ()=>{ // 画面遷移時に再描画するために必要 1/2
//bf.l('21: here')
      cf.myLS_chk()
      .then( _b_res => {
        _o_this.setState({
          sb_cookie: _b_res,
        }, () => {
        });
      });
      if (bf.f(global.c?.state.sgcd_pageCmns?.user_key)){ // 認証済の場合
//bf.l('30: here')
        //
        let _cnd = bf.q('[_KEY]={}'.f(
          global.c?.state.sgcd_pageCmns?.user_key
        ));
        cf.myCB_call_slc({
          ctr: 'nlm', 
          elm: 'cm10', 
          n_dms: 2, 
          cnd: _cnd
        })
        .then( _d_cm10s => {
          global.c?._setCm10s(_d_cm10s)
        });
      }
      else { // 未認証の場合
//bf.l('45: here')
        global.c?.setState({ // ログイン画面の表示
          sgc_eml: '',
          sgc_nmb: '',
          sgc_pagePrc: '10',
        });
      };
    });
  }

/*
  _setCm10s = pd_cm10s => {
    global.c?.setState({
      sgcd_pageCmns: bf.p(global.c?.state.sgcd_pageCmns, _next => {
        _next.user_key = pd_cm10s._KEY;
        _next.userb21k = pd_cm10s.cm10b21k;
        _next.userc410 = pd_cm10s.cm10c410;
        _next.userc310 = pd_cm10s.cm10c310;
        _next.userc330 = pd_cm10s.cm10c330;
        _next.cm10_key = pd_cm10s._KEY;
        _next.cm10b21k = pd_cm10s.cm10b21k;
        _next.cm10c410 = pd_cm10s.cm10c410;
        _next.cm10c310 = pd_cm10s.cm10c310;
        _next.cm10c330 = pd_cm10s.cm10c330;
        _next.cm10_pfx = (pd_cm10s.cm10c330) ? pd_cm10s.cm10c330 : (pd_cm10s.cm10c310 || '');
      }),
    }, () => {
      //
      new Promise( _o_end1 => {
        if (bf.f(pd_cm10s.cm10b21k)) { // cm20_key が指定されている場合
          let _cnd2 = bf.q('[_KEY]={}'.f(pd_cm10s.cm10b21k));
          cf.myCB_call_slc({
            ctr: 'nlm', 
            elm: 'cm20', 
            n_dms: 2, 
            cnd: _cnd2, 
          })
          .then( _d_cm20s => {
            if (_d_cm20s) {
//bf.l('111:{}'.f(global.c?.state.sgcd_pageCmns))
              global.c?.setState({
                sgcd_pageCmns: bf.p(global.c?.state.sgcd_pageCmns, _next => {
                  _next.cm20_key = _d_cm20s._KEY;
//                  _next.cm20c310 = _d_cm20s.cm20c310;
//                  _next.cm20c330 = _d_cm20s.cm20c330;
//                  _next.cm20c310 = _d_cm20s.cm20c310;
                  _next.cm20_pfx = (_d_cm20s.cm20c330) ? _d_cm20s.cm20c330 : (_d_cm20s.cm20c310 || '');
                }),
              }, () => {
                _o_end1();
              });
            }
            else {
              _o_end1();
            };
          });
        }
        else {
          _o_end1();
        };
      })
      .then(()=>{
        let _d_pageInfs =  iv.get_iniPageInfs(pd_cm10s._KEY, pd_cm10s.cm10c410);
//bf.l('132:{}'.f(_d_pageInfs))
        cf.myRN_move_fwd(_d_pageInfs);
      });
    })
  };
*/
  _setCm10s = pd_cm10s => {
    cf.myRN_setCmns({
        user_key: pd_cm10s._KEY,
        userb21k: pd_cm10s.cm10b21k,
        userc410: pd_cm10s.cm10c410,
        user_pfx: (pd_cm10s.cm10c330) ? pd_cm10s.cm10c330 : (pd_cm10s.cm10c310 || ''),
        useri110: pd_cm10s.cm10i110,
        cm10_key: pd_cm10s._KEY,
        cm10b21k: pd_cm10s.cm10b21k,
        cm10c410: pd_cm10s.cm10c410,
        cm10_pfx: (pd_cm10s.cm10c330) ? pd_cm10s.cm10c330 : (pd_cm10s.cm10c310 || ''),
    })
    .then( () => {
      //
      new Promise( _o_end1 => {
        if (bf.f(pd_cm10s.cm10b21k)) { // cm20_key が指定されている場合
          let _cnd2 = bf.q('[_KEY]={}'.f(pd_cm10s.cm10b21k));
          cf.myCB_call_slc({
            ctr: 'nlm', 
            elm: 'cm20', 
            n_dms: 2, 
            cnd: _cnd2, 
          })
          .then( _d_cm20s => {
            if (_d_cm20s) {
              cf.myRN_setCmns({
                cm20_key: _d_cm20s._KEY,
                cm20_pfx: (_d_cm20s.cm20c330) ? _d_cm20s.cm20c330 : (_d_cm20s.cm20c310 || ''),
              })
              .then(() => {
                _o_end1();
              });
            }
            else {
              _o_end1();
            };
          });
        }
        else {
          _o_end1();
        };
      })
      .then(()=>{
        let _d_pageInfs =  iv.get_iniPageInfs(pd_cm10s._KEY, pd_cm10s.cm10c410);
//bf.l('132:{}'.f(_d_pageInfs))
        cf.myRN_move_fwd(_d_pageInfs);
      });
    })
  };

  componentWillUnmount() {
    cf.myRN_end(); // 画面遷移時に再描画するために必要 2/2
  }

  load = () => {
  }
  
  render() {
    return (
      <ce.Root
      >
        <ce.Bdy
          stlCta={{
            height: ic.gn_h,
            top: 0,
            flex: 1,
            flexDirection: 'column',
            justifyContent: 'space-between',
            alignItems: 'center',
          }}
        >
          { (global.c?.state.sgc_pagePrc == '10') ? // ログイン画面の表示

            <ce.Box
            >

              { (iv.gd_stgs.cLgn.b_alwNewUser == true) ? // 新規ユーザ登録を行う場合
                <>
                  <ce.Msg
                    pfx={'新規に利用者登録を行う場合は、新規登録ボタンを押してください。'}
                    stlCta={{
                      marginTop: ic.gn_hdrBarH + ic.gn_mgnLrg * 2,
                    }}
                  />
                  <ce.Btn
                    pfx={'新規登録'}
                    onPrs={()=>{ // 新規利用者登録の場合
                      global.c?.setState({
                        sgc_pagePrc: '11'
                      });
                    }}
                    stlCta={{
                      marginTop: ic.gn_mgnLrg,
                      marginBottom: ic.gn_mgnLrg,
                    }}
                    stlBtn={{
                      width: ic.gn_btnWLrg,
                    }}
                  />
                  <ce.Spr
                  />
                </>
              : null }

              <ce.Msg
                pfx={
                  (iv.gd_stgs.cLgn.b_alwNewUser == true) ?
                    `既に利用者登録を行っている場合は、メールアドレスを入力し、送るボタンを押してください。`
                  :
                    `登録済のメールアドレスを入力し、送るボタンを押してください。`
                }
                stlCta={{
                  marginTop: ic.gn_hdrBarH + ic.gn_mgnLrg * 2,
                }}
              />

              <ce.Inp
                state={'sgc_eml'}
                b_edt={true}
                pfx={'メールアドレス'}
              />

              <ce.Btn
                pfx={'送る'}
                onPrs={()=>{
                  //
                  cf.myRN_ldr_show(); // drawler の表示
                  //
                  let _eml = bf.myCM_cnv('lwr', global.c?.state.sgc_eml);
                  //
/*
                  cf.myCB_call_nmb(_eml)
                  .then(()=>{
                    global.c?.setState({ // 確認番号の確認
                      sgc_pagePrc: '21',
                    })
                    cf.myRN_ldr_hide(); // drawler の非表示
                  });
*/

                  if ( true ) cf.myCB_call_nmb(_eml)
//                  if ( false ) cf.myCB_call_nmb(_eml) // debug only
                  global.c?.setState({ // 確認番号の確認
                    sgc_pagePrc: '21',
                  })
                  cf.myRN_ldr_hide(); // drawler の非表示
                }}
                stlCta={{
                  marginTop: ic.gn_mgnLrg,
                  marginBottom: ic.gn_mgnLrg,
                }}
              />

            </ce.Box>

        : null }

          { (global.c?.state.sgc_pagePrc == '11') ? // 新規利用者登録を行う場合
          
            <ce.Box
            >

              <ce.Msg
                pfx={(
                  (iv.gd_stgs.cLgn.b_usePcy == true) ?
                    <Text>
                      <ce.Link
                        url={'{}/{}'.f(ic.g_url2, 'terms_sy4741.pdf')}
                      >利用規約</ce.Link> に同意いただける場合、メールアドレスを入力し、利用規約に同意し送るボタンを押してください。
                    </Text>
                  :
                    <Text>
                      メールアドレスを入力し、送るボタンを押してください。
                    </Text>
                )}
                stlCta={{
                  marginTop: ic.gn_hdrBarH + ic.gn_mgnLrg * 2,
                }}
              />

              <ce.Inp
                state={'sgc_eml'}
                b_edt={true}
                pfx={'メールアドレス'}
              />

              <ce.Btn
                pfx={
                  (iv.gd_stgs.cLgn.b_usePcy == true) ?
                    '利用規約に同意し送る'
                  :
                    '送る'
                }
                onPrs={()=>{
                  //
                  cf.myRN_ldr_show(); // drawler の表示
                  //
                  cf.myCB_call_nmb(bf.myCM_cnv('lwr', global.c?.state.sgc_eml))
                  .then((_d_res)=>{
                    global.c?.setState({
                      sgc_pagePrc: '12',
                    })
                    cf.myRN_ldr_hide(); // drawler の非表示
                  });
                }}
                stlBtn={{
                  width: 
                    (iv.gd_stgs.cLgn.b_usePcy == true) ?
                      ic.gn_btnWLrg * 2
                    :
                      ic.gn_btnWLrg,
                }}
              />

            </ce.Box>
          
          : null }

          { (global.c?.state.sgc_pagePrc == '12') ?

            <ce.Box
            >

              <ce.Msg
                pfx={'メールアドレス宛に送信された確認番号を入力ください。（30分以内）'}
                stlCta={{
                  marginTop: ic.gn_hdrBarH + ic.gn_mgnLrg * 2,
                }}
              />

              <ce.Inp
                state={'sgc_nmb'}
                b_edt={true}
                pfx={'確認番号'}
              />

              <ce.Btn
                pfx={'送る'}
                onPrs={ async ()=>{
                  //
                  cf.myCB_call_cnf(bf.myCM_cnv('lwr', global.c?.state.sgc_eml), global.c?.state.sgc_nmb)
                  .then((_d_ress) => {
                    //
                    if (_d_ress.result == 1) { // 新規登録の場合
                        //
                        cf.myLS_set('tkn', _d_ress.tkn);
                        global.c?.setState({
                          sgc_user_key: _d_ress.user_key,
                          sgc_tkn: _d_ress.tkn,
                        },()=>{
//                          let _cnd1 = bf.q('[cm10i110]="{}"'.f(global.c?.state.sgc_eml))
                          let _cnd1 = bf.q('[cm10i110]="{}"'.f(bf.myCM_cnv('lwr', global.c?.state.sgc_eml)))
                          cf.myCB_call_slc({
                            ctr: 'nlm', 
                            elm: 'cm10', 
                            n_dms: 2, 
                            cnd: _cnd1
                          })
                          .then((_d_cm10s) =>{
                            new Promise( _end1 => {
                              //
                              if (bf.f(_d_cm10s)){ // ユーザ登録が行われている場合
                                _end1(_d_cm10s);
                              }
                              else{ // ユーザ登録が行われていない場合
                                let _d_vals = {
                                  cm10b11k: global.c?.state.sgc_user_key,
                                  cm10c110: '',
                                  cm10c310: '',
                                  cm10c410: '10',
                                  cm10c610: '',
                                  cm10cz10: '10',
//                                  cm10i110: global.c?.state.sgc_eml,
                                  cm10i110: bf.myCM_cnv('lwr', global.c?.state.sgc_eml),
                                };
                                cf.myCB_call_iud({
                                  ctr: 'ins', 
                                  elm: 'cm10', 
                                  d_vals: _d_vals
                                })
                                .then((_d_cm10s)=>{
                                  _end1(_d_cm10s);
                                });
                              };
                            })
                            .then((_d_cm10s)=>{
                              global.c?._setCm10s(_d_cm10s);
                            });
                          });
                        });
                      }
                      else {
                        alert('認証に失敗しました。最初からお願いします。')
                        global.c?.setState({
                          sgc_eml: '',
                          sgc_nmb: '',
                          sgc_pagePrc: '10',
                        });
                      };
                  });
                }}
              />
                
            </ce.Box>

          : null }

          { (global.c?.state.sgc_pagePrc == '21') ?

            <ce.Box
            >

              <ce.Msg
                pfx={'メールアドレス宛に送信された確認番号を入力し、送るボタンを押してください。（30分以内）'}
                stlCta={{
                  marginTop: ic.gn_hdrBarH + ic.gn_mgnLrg * 2,
                }}
              />

              <ce.Inp
                state={'sgc_nmb'}
                b_edt={true}
                pfx={'確認番号'}
              />

              <ce.Btn
                pfx={'送る'}
                onPrs={async ()=>{
                  //
                  let _eml = bf.myCM_cnv('lwr', global.c?.state.sgc_eml);

                  let _d_ress = null;
                  if ( false ) {
//                  if ( true ) { // debug only
                    if ( bf.n(global.c?.state.sgc_nmb) == 519832 ) {
                      _d_ress = {
                        result: 1,
                        tkn: 'debug',
                      };
                    } 
                    else {
                      _d_ress = {
                        result: 0,
                      };
                    }
                  }
                  else {
                    _d_ress = await cf.myCB_call_cnf(_eml, global.c?.state.sgc_nmb)
                  };

//bf.l('528: {}'.f(_d_ress))
//                  if (_d_ress.n_sts == 1) { // 新規登録の場合
                  if (_d_ress.result == 1) { // 新規登録の場合
                    //
                    new Promise( _o_end1 => {
                      cf.myRN_setCmns({
                        tkn: _d_ress.tkn,
                      })
                      .then(() => {
                        _o_end1();
                      });
                    })
                    .then( () => {
//                      let _eml = bf.myCM_cnv('lwr', global.c?.state.sgc_eml);
                      let _cnd1 = bf.q(`
                        [_KEY]=(
                          SELECT 
                            MIN([_KEY]) 
                          FROM 
                            [t_cm10] 
                          WHERE 
                            [cm10i110]="{}" AND
                            IFNULL([cm10cz10],"10")<>"0"
                        )
                      `.f(
                        _eml
                      )) // ユーザの登録状況は、メールアドレスにより確認すべきでは？
//bf.l('590: {}'.f(_cnd1));
//bf.l('559: {}'.f(_cnd1))
                      cf.myCB_call_slc({
                        ctr: 'nlm', 
                        elm: 'cm10', 
                        n_dms: 2, 
                        cnd: _cnd1
                      })
                      .then((_d_cm10s) =>{
//bf.l('598: here')
//bf.l('568: {}'.f(_d_cm10s))
//                        global.c?._setCm10s(_d_cm10s);                            
                        if (bf.f(_d_cm10s)) {
                          global.c?._setCm10s(_d_cm10s);                            
                        }
                        else {
                          alert('認証に失敗しました。最初からお願いします。')
                          global.c?.setState({
                              sgc_eml: '',
                              sgc_nmb: '',
                              s_step: '10',
                          });
                        };
                      });
                    });
                  }
                  else {
                    alert('認証に失敗しました。最初からお願いします。')
                    global.c?.setState({
                        sgc_eml: '',
                        sgc_nmb: '',
                        s_step: '10',
                    });
                  };
                }}
              />
                  
            </ce.Box>
          : null }

          <ce.Box
            stlCta={{
              marginTop: ic.gn_mgnLrg * 2,
            }}
          >
            <ce.Msg
              b_vsb={(this.state.sb_cookie == true) ? false : true}
              pfx={'※ ブラウザのクッキーを有効にしてください。'}
              stlCta={{
                marginTop: ic.gn_mgnLrg,
                marginBottom: 0,
              }}
              stlPfx={{
                fontSize: ic.gn_fontSizeSml,
                color: ic.g_ccdRN,
              }}
            />
            <ce.Msg
              b_vsb={true}
              pfx={'※ 入力したメールアドレス宛に確認番号が送信されない場合は、使用しているメールアプリやキャリアの受信設定も確認ください。'}
              stlCta={{
                marginTop: ic.gn_mgnLrg,
                marginBottom: 0,
              }}
              stlPfx={{
                fontSize: ic.gn_fontSizeSml,
              }}
            />
            <ce.Msg
              b_vsb={true}
              pfx={'※ 正しい確認番号を入力したにも関わらずログインに失敗する場合は、システムに登録されているメールアドレスも確認ください。'}
              stlCta={{
  //              marginTop: ic.gn_hdrBarH + ic.gn_mgnLrg * 2,
                marginTop: ic.gn_mgnLrg,
                marginBottom: 0,
              }}
              stlPfx={{
                fontSize: ic.gn_fontSizeSml,
              }}
            />
          </ce.Box>
        </ce.Bdy>
      </ce.Root>
    );
  }
}

export default cLgn;
